import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Pagination,
  LoadedContent,
  TableContainer,
} from '@occc-app/design-system';
import { RetailerNetworkLocationForMemberFragment } from '@occc/graphql';

import { RetailerNetworkLocationsForMemberRow } from './RetailerNetworkLocationsForMemberRow';

import { useMembershipEmployeeData } from '../../../hooks/useMembershipEmployeeData';

type RetailerNetworkLocationsForMemberTableProps = {
  employeeLocations: ReturnType<typeof useMembershipEmployeeData>['employeeLocations'];
};

export const RetailerNetworkLocationsForMemberTable = ({
  employeeLocations,
}: RetailerNetworkLocationsForMemberTableProps) => {
  const { loading: locationsLoading, error, data, paginationProps } = employeeLocations;

  const renderData = (items: RetailerNetworkLocationForMemberFragment[]) => (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Site ID</TableCell>
            <TableCell>Site Name</TableCell>
            <TableCell>Employee Type</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((location) => (
            <RetailerNetworkLocationsForMemberRow key={location.uuid} location={location} />
          ))}
        </TableBody>
      </Table>
      <Pagination {...paginationProps} />
    </TableContainer>
  );

  return (
    <LoadedContent<RetailerNetworkLocationForMemberFragment>
      error={error}
      loading={locationsLoading}
      items={data}
      renderData={renderData}
    />
  );
};
